module.exports = __webpack_public_path__ + "static/media/publico.b11ed8b4.svg";